import React from 'react'

const TopBar = ({ 
  tab, 
  onTab, 
  onHome, 
  session, 
  onLogout, 
  showAdminLinks, 
  statusLabel,
  onShowLogin 
}) => {
  const handleTabClick = (newTab) => {
    if (session?.role === 'member' && newTab !== 'PERSONAL') return
    onTab(newTab)
  }

  return (
    <div className="topbar">
      <div className="brand">
        <img className="logo-img" src="/Bfit_Logo-01.png" alt="BFIT logo" />
        <div className="brand-wordmark">
          B F I T <span className="accent">•</span> P R O G R E S S I O N
        </div>
      </div>
      
      <div className="nav">
        {showAdminLinks && (
          <>
            <a 
              className={tab === 'KIOSK' ? 'active' : ''} 
              onClick={() => handleTabClick('KIOSK')}
            >
              KIOSK
            </a>
            <a 
              className={tab === 'ADMIN' ? 'active' : ''} 
              onClick={() => handleTabClick('ADMIN')}
            >
              ADMIN
            </a>
            <a 
              className={tab === 'BUILDER' ? 'active' : ''} 
              onClick={() => handleTabClick('BUILDER')}
            >
              BUILDER
            </a>
            <a 
              className={tab === 'EXPORT' ? 'active' : ''} 
              onClick={() => handleTabClick('EXPORT')}
            >
              EXPORT
            </a>
          </>
        )}
        
        {session?.role !== 'member' && (
          <a onClick={onHome}>
            <span className="chip">HOME</span>
          </a>
        )}
        
        <span className="status">{statusLabel}</span>
        
        {session ? (
          <a onClick={onLogout} className="logout-btn">
            LOG OUT
          </a>
        ) : (
          <a 
            onClick={onShowLogin} 
            className={tab === 'PERSONAL' ? 'active' : ''}
          >
            LOGIN
          </a>
        )}
      </div>
    </div>
  )
}

export default TopBar
